import { valueOf2fyebtslgrf1c as valueOf } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/HttpHeaders.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { onCompletion2zzj1m13j2omp as onCompletion } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Emitters.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  trim11nh7r46at6sx as trim,
  trim6jpmwojjgb3l as trim_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { MultipartReader25md2ukkr9jti as MultipartReader } from './MultipartReader.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_isGraphQLResponse(_this__u8e3s4) {
  var tmp0_safe_receiver = valueOf(_this__u8e3s4.u4b_1, 'Content-Type');
  return (tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, 'application/graphql-response+json', true)) === true;
}
function get_isMultipart(_this__u8e3s4) {
  var tmp0_safe_receiver = valueOf(_this__u8e3s4.u4b_1, 'Content-Type');
  return (tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, 'multipart/', true)) === true;
}
function multipartBodyFlow(response) {
  var multipartReader = {_v: null};
  var tmp = flow(multipartBodyFlow$slambda(multipartReader, response));
  return onCompletion(tmp, multipartBodyFlow$slambda_0(multipartReader));
}
function getBoundaryParameter(contentType) {
  if (contentType == null)
    return null;
  // Inline function 'kotlin.collections.map' call
  var this_0 = split(contentType, charArrayOf([_Char___init__impl__6a9atx(59)]));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().i2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$2 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
    destination.j2(tmp$ret$2);
  }
  var parameters = destination;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = parameters.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      if (startsWith(element, 'boundary=')) {
        tmp$ret$4 = element;
        break $l$block;
      }
    }
    tmp$ret$4 = null;
  }
  var boundaryParameter = tmp$ret$4;
  var tmp1_safe_receiver = boundaryParameter == null ? null : split(boundaryParameter, charArrayOf([_Char___init__impl__6a9atx(61)]));
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : getOrNull(tmp1_safe_receiver, 1);
  return tmp2_safe_receiver == null ? null : trim_0(tmp2_safe_receiver, charArrayOf([_Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(39)]));
}
function multipartBodyFlow$slambda($multipartReader, $response) {
  return constructCallableReference(($this$flow, $completion) => orPromise($completion, function *($completion) {
    var tmp = ensureNotNull($response.y4b());
    var tmp0_elvis_lhs = getBoundaryParameter(valueOf($response.u4b_1, 'Content-Type'));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw DefaultApolloException().d45('Expected the Content-Type to have a boundary parameter');
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    $multipartReader._v = new (MultipartReader())(tmp, tmp_0);
    $l$loop: while (true) {
      var tmp1_elvis_lhs = ensureNotNull($multipartReader._v).z66();
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var part = tmp_1;
      yield* $this$flow.q1e(part.y66_1, $completion);
    }
    return Unit_instance;
  }), 1);
}
function multipartBodyFlow$slambda_0($multipartReader) {
  return constructCallableReference(($this$onCompletion, it, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      var tmp0_safe_receiver = $multipartReader._v;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp0_safe_receiver.m6();
        tmp_0 = Unit_instance;
      }
      // Inline function 'kotlin.Companion.success' call
      var value = tmp_0;
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }), 2);
}
//region block: exports
export {
  get_isGraphQLResponse as get_isGraphQLResponse3ogjhw8yzfes1,
  get_isMultipart as get_isMultipart1je26zsopcnca,
  multipartBodyFlow as multipartBodyFlow272n2l39kgnug,
};
//endregion

//# sourceMappingURL=multipart.mjs.map
